// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { Tenant } from "./Tenant";
import { TenantFromJSON, TenantFromJSONTyped, TenantToJSON, TenantToJSONTyped } from "./Tenant";
import type { StorageUsage } from "./StorageUsage";
import {
  StorageUsageFromJSON,
  StorageUsageFromJSONTyped,
  StorageUsageToJSON,
  StorageUsageToJSONTyped,
} from "./StorageUsage";

/**
 * A tenant's daily snapshot of usage values.
 * @export
 * @interface DailyUsage
 */
export interface DailyUsage {
  /**
   *
   */
  id: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  tenant: Tenant;
  /**
   *
   */
  usageDate: Date;
  /**
   *
   */
  storage: StorageUsage;
}

/**
 * Check if a given object implements the DailyUsage interface.
 */
export function instanceOfDailyUsage(value: object): value is DailyUsage {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (!("tenant" in value) || value["tenant"] === undefined) return false;
  if (
    (!("usageDate" in (value as Record<string, any>)) &&
      !("usage_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["usageDate"] === undefined &&
      (value as Record<string, any>)["usage_date"] === undefined)
  )
    return false;
  if (!("storage" in value) || value["storage"] === undefined) return false;
  return true;
}

export function DailyUsageFromJSON(json: any): DailyUsage {
  return DailyUsageFromJSONTyped(json, false);
}

export function DailyUsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyUsage {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    tenant: TenantFromJSON(json["tenant"]),
    usageDate: json["usage_date"] == null ? json["usage_date"] : parseDate(json["usage_date"]),
    storage: StorageUsageFromJSON(json["storage"]),
  };
}

export function DailyUsageToJSON(json: any): DailyUsage {
  return DailyUsageToJSONTyped(json, false);
}

export function DailyUsageToJSONTyped(
  value?: DailyUsage | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    tenant: TenantToJSON(value["tenant"]),
    usage_date: value["usageDate"] == null ? value["usageDate"] : serializeDate(value["usageDate"]),
    storage: StorageUsageToJSON(value["storage"]),
  };
}
